export default __webpack_public_path__ + "static/media/arrow.3fe8cd4e.svg";